import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation, PapiGallection } from '@wix/da-papi-types';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton/IconButton';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import LinkIcon from '@wix/da-ds/pkg/Icons/24x24/Link';
import { useCopyDeviationOrGallectionLinkClick } from '@wix/da-shared-react/pkg/utils/hooks/useCopyLinkClick';
import { BiEvent } from '@wix/da-bi/pkg/events';

interface BaseProps {
  size?: ButtonSize;
  className?: string;
  variant?: 'icon' | 'icon-with-background';
  biData?: BiEvent;
}
type DeviationLinkProps = BaseProps & {
  deviation: PapiDeviation;
  gallection?: never;
};
type GallectionLinkProps = BaseProps & {
  deviation?: never;
  gallection: PapiGallection;
};

const CopyLinkButton: FC<DeviationLinkProps | GallectionLinkProps> = ({
  deviation,
  gallection,
  size = 'medium',
  className,
  variant = 'icon',
  biData,
}) => {
  const { t } = useTranslation();
  const { onCopyLinkClick } = useCopyDeviationOrGallectionLinkClick(deviation, gallection);
  const IconComponent = variant === 'icon' ? IconButton : IconButtonWithBackground;

  return (
    <IconComponent
      className={className}
      icon={LinkIcon}
      size={size}
      onClick={onCopyLinkClick}
      title={t('studio.table.actions.copyLink')}
      aria-label={t('studio.table.actions.copyLink')}
      biData={biData}
    />
  );
};
CopyLinkButton.displayName = 'CopyLinkButton';

export default CopyLinkButton;
